import NextLink from 'next/link';

export default function MobileMenu() {
	return (
		<div>
			<details className="[open:padding:5rem] py-2 border-b-2">
				<summary className="cursor-pointer list-none text-white">
					<strong className="text-white font-bold">Sobre o Instituto</strong>
				</summary>
				<ul className="text-white py-2">
					<li className="border-b-2 border-white py-2">
						<NextLink href="/sobre-o-instituto/nossa-historia">
							Conheça o Instituto
						</NextLink>
					</li>
					<li className="border-b-2 border-white py-2">
						<NextLink href="/sobre-o-instituto/por-que-existimos">
							Por que existimos?
						</NextLink>
					</li>
					<li className="border-b-2 border-white py-2">
						<NextLink href="/sobre-o-instituto/quem-faz-acontecer">
							Quem faz acontecer
						</NextLink>
					</li>
					<li className="border-b-2 border-white py-2">
						<NextLink href="/cartao-doador">Cartão Doador</NextLink>
					</li>
					<li className="border-b-2 border-white py-2">
						<NextLink href="/sobre-o-instituto/transparencia">
							Transparência
						</NextLink>
					</li>
				</ul>
			</details>

			<details className="[open:padding:5rem] py-2 border-b-2">
				<summary className="cursor-pointer list-none text-white">
					<strong className="text-white font-bold">O que fazemos</strong>
				</summary>
				<ul className="text-white py-2">
					<li className="py-2 border-b-2 border-white">
						<NextLink
							className="flex"
							href="/o-que-fazemos/educar-para-doar"
							tabIndex={0}
						>
							Informar, Inspirar e conscientizar: doação de órgãos
						</NextLink>
					</li>
					<li className="py-2 border-b-2 border-white">
						<NextLink
							className="flex py-1"
							href="/o-que-fazemos/saude-renal"
							tabIndex={0}
						>
							Saúde Renal: cuidado e prevenção
						</NextLink>
					</li>
					<li className="py-2 border-b-2 border-white">
						<NextLink
							className="flex py-1"
							href="/o-que-fazemos/rede-de-acolhimento"
							tabIndex={0}
						>
							Rede de Acolhimento: pacientes e cuidadores
						</NextLink>
					</li>
				</ul>
			</details>

			<details className="[open:padding:5rem] py-2 border-b-2">
				<summary className="cursor-pointer list-none text-white">
					<strong className="text-white font-bold">Podcast</strong>
				</summary>
				<ul className="text-white py-2">
					<li className="py-2 border-b-2 border-white">
						<NextLink
							className="flex"
							href="https://www.youtube.com/@deixevivo"
							target="_blank"
							tabIndex={0}
						>
							YouTube
						</NextLink>
					</li>
					<li className="py-2 border-b-2 border-white">
						<NextLink
							className="flex py-1"
							href="https://open.spotify.com/show/38absqTWyntQNAqSfxgq4l?si=3cf2d02bfdd3468b"
							target="_blank"
							tabIndex={0}
						>
							Spotify
						</NextLink>
					</li>
				</ul>
			</details>

			<NextLink
				href="https://blog.deixevivo.org.br"
				target="_blank"
				className="accordion-title w-full flex items-center justify-between py-2 text-white border-b-2"
				aria-label="Acesse nosso blog"
				tabIndex={0}
			>
				<span className="font-bold">Blog</span>
			</NextLink>

			<NextLink
				href="https://reserva.ink/deixevivo"
				target="_blank"
				className="accordion-title w-full flex items-center justify-between py-2 text-white border-b-2"
				aria-label="Acesse nossa loja virtual"
				tabIndex={0}
			>
				<span className="font-bold">Loja Virtual</span>
			</NextLink>
		</div>
	);
}
